import { render, staticRenderFns } from "./OnboardingResult.vue?vue&type=template&id=06364a27&"
import script from "./OnboardingResult.ts?vue&type=script&lang=ts&"
export * from "./OnboardingResult.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports